import {EventEmitter} from "eventemitter3";

import {PlayerController, PlayerControllerEvents} from "./PlayerController.js";

// Your Zod schema type

/**
 * A controller for a "ghost" player that replays a pre-recorded set of actions.
 */
export class GhostPlayerController
  extends EventEmitter<PlayerControllerEvents>
  implements PlayerController
{
  public readonly uid: string;
  private readonly actions: boolean[];

  constructor(uid: string, actions: boolean[]) {
    super();
    this.uid = uid;
    this.actions = actions;
  }

  getAllActions(): boolean[] {
    return this.actions;
  }

  /**
   * Called by the GameManager at each simulation step.
   */
  public getActionForStep(step: number): boolean {
    if (step >= this.actions.length)
      return this.actions[this.actions.length - 1] ?? false;
    return this.actions[step]!;
  }

  /**
   * Resets the controller. Since the replay data is immutable, this does nothing.
   */
  public reset(): void {
    // No state to reset for a ghost.
  }
}
